import { useAxiosWithAuth } from '@fuel/api'

const useChallengeAuth = () => {
  const axiosApi = useAxiosWithAuth('Bearer ', process.env.NEXT_PUBLIC_CHALLENGES_URL)

  return axiosApi
}

export default useChallengeAuth
